import React from "react";

export const isFiltersSubmitKey = (e: React.KeyboardEvent): boolean => {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing) {
    return false;
  }
  const target = e.target as HTMLElement | null;
  if (!target || target.tagName !== "INPUT") return false;
  return target.getAttribute("aria-expanded") !== "true";
};

export const handleFiltersEnter = (
  e: React.KeyboardEvent,
  apply: () => void,
): void => {
  if (!isFiltersSubmitKey(e)) return;
  e.preventDefault();
  apply();
};
